import { FC } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface FeedbackConfirmModalProps {
  open: boolean;
  close: (cancel: boolean) => void;
}

const FeedbackConfirmModal: FC<FeedbackConfirmModalProps> = ({ open, close }) => {
  return (
    <Dialog
      open={open}
      onClose={() => close(true)}
      aria-labelledby="send-nda-dialog"
      aria-describedby="send-nda-dialog"
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '28px',
          width: 'min(80%, 430px)',
          padding: '1.5rem',
        },
      }}
    >
      <DialogTitle
        id="send-nda-dialog-title"
        sx={{
          fontSize: '1.5rem',
          fontWeight: 700,
          lineHeight: '2rem',
          color: '#162936',
          padding: 0,
          pb: '1rem',
        }}
      >
        Feedback Received!
      </DialogTitle>
      <DialogContent
        sx={{
          p: 0,
        }}
      >
        <DialogContentText
          fontSize={'0.875rem'}
          fontWeight={500}
          lineHeight={'1.25rem'}
          color={'#6C6C6C'}
          id="send-nda-dialog-description"
        >
          We have received your feedback, our team will get back to you shortly.
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: 0,
          pt: '1.5rem',
        }}
      >
        <Button
          onClick={() => close(true)}
          variant="contained"
          disableElevation
          disableFocusRipple
          disableRipple
          disableTouchRipple
          sx={{
            borderRadius: '100px',
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
            padding: '0.625rem 1.5rem',
            textTransform: 'none',
            fontWeight: 700,
            background: '#2F736E',
            color: '#fff',
          }}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackConfirmModal;
